/**
 * Подпись применённых фильтров для шапки выгрузки списка задач.
 *
 * Строится на клиенте: только он знает имена исполнителей, приоритетов
 * и типов, выбранных в фильтре. Сервер кладёт её в файл как есть.
 * Общая для сайта и приложения: файл с телефона подписан так же.
 */

import { NO_ASSIGNEE, NO_ASSIGNEE_LABEL, type TaskFilterState } from "./filters";

interface PickerOption {
  id: string;
  label: string;
}

/** «ДД.ММ.ГГГГ» из ISO-даты — строкой, без Date и часовых поясов. */
function formatDate(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return match === null ? iso : `${match[3] ?? ""}.${match[2] ?? ""}.${match[1] ?? ""}`;
}

function names(ids: string[], options: PickerOption[]): string {
  return ids.map((id) => options.find((option) => option.id === id)?.label ?? "—").join(", ");
}

export function exportFiltersLabel(
  filters: TaskFilterState,
  options: { assignees: PickerOption[]; priorities: PickerOption[]; types: PickerOption[] },
): string {
  const parts: string[] = [];
  if (filters.myToday) parts.push("мои задачи на сегодня и просроченные");
  if (filters.search !== "") parts.push(`поиск «${filters.search}»`);
  if (filters.state === "open") parts.push("статус: открытые");
  if (filters.state === "done") parts.push("статус: готовые");
  if (filters.assigneeIds.length > 0) {
    parts.push(
      `исполнители: ${names(filters.assigneeIds, [{ id: NO_ASSIGNEE, label: NO_ASSIGNEE_LABEL.toLowerCase() }, ...options.assignees])}`,
    );
  }
  if (filters.priorityIds.length > 0) {
    parts.push(`приоритет: ${names(filters.priorityIds, options.priorities)}`);
  }
  if (filters.typeIds.length > 0) parts.push(`тип: ${names(filters.typeIds, options.types)}`);
  if (filters.dueFrom !== null || filters.dueTo !== null) {
    const from = filters.dueFrom === null ? "…" : formatDate(filters.dueFrom);
    const to = filters.dueTo === null ? "…" : formatDate(filters.dueTo);
    // Выгрузка — только у списка подразделения, а там период — работы.
    parts.push(`период работы: ${from} — ${to}`);
  }
  if (filters.overdueOnly) parts.push("только просроченные");
  if (filters.mineOnly) parts.push("только мои");
  return parts.length === 0 ? "без фильтров" : parts.join("; ");
}
